export default function Privacy() {
  return (
    <div data-testid="page-privacy" className="py-20 md:py-28">
      <div className="max-w-3xl mx-auto container-px">
        <p className="eyebrow">Document legal</p>
        <h1 className="h-display text-4xl md:text-5xl text-text mt-4">Politică de confidențialitate</h1>
        <div className="mt-10 space-y-6 text-text-soft leading-relaxed">
          <p>DOTAPAN SRL respectă confidențialitatea datelor partenerilor și vizitatorilor săi, conform GDPR.</p>
          <h2 className="font-display text-2xl text-text mt-8">Date colectate</h2>
          <p>Colectăm doar datele necesare pentru a răspunde solicitărilor tale: nume, companie, telefon, email, județ, tip afacere și mesajul transmis prin formular.</p>
          <h2 className="font-display text-2xl text-text mt-8">Scopul prelucrării</h2>
          <p>Folosim datele exclusiv pentru a-ți răspunde, a-ți trimite ofertă personalizată și a menține relația comercială. Nu transmitem datele tale către terți pentru marketing.</p>
          <h2 className="font-display text-2xl text-text mt-8">Drepturile tale</h2>
          <p>Ai dreptul de acces, rectificare, ștergere și opoziție. Scrie-ne la dotapanromania@gmail.com pentru orice solicitare.</p>
          <h2 className="font-display text-2xl text-text mt-8">Cookies</h2>
          <p>Folosim cookies tehnice pentru funcționarea normală a site-ului. Nu utilizăm cookies de profilare invazivă.</p>
        </div>
      </div>
    </div>
  );
}
